import type { ButtonHTMLAttributes } from 'react'
import React from 'react'

import type { BaseIconButtonProps } from './BaseIconButton'
import { BaseIconButton } from './BaseIconButton'

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  Omit<BaseIconButtonProps, 'children'> & {
    'data-test-id'?: string
  } & { ref?: React.Ref<HTMLButtonElement> }

export function IconButton({
  icon,
  variant,
  size,
  isActive,
  disabled,
  'data-test-id': dataTestId,
  onClick,
  className,
  style,
  iconClassname,
  iconSize,
  iconStyle,
  type,
  disableFocus,
  transparent,
  rounded,
  ref,
  ...otherProps
}: IconButtonProps) {
  return (
    <BaseIconButton
      className={className}
      style={style}
      disabled={disabled}
      disableFocus={disableFocus}
      isActive={isActive}
      size={size}
      variant={variant}
      icon={icon}
      iconSize={iconSize}
      iconStyle={iconStyle}
      iconClassname={iconClassname}
      transparent={transparent}
      rounded={rounded}
    >
      {(outerClassName, outerStyle, innerClassName, innerStyle, children) => (
        <button
          ref={ref}
          type={type}
          onClick={onClick}
          className={outerClassName}
          style={outerStyle}
          disabled={disabled}
          data-test-id={dataTestId}
          {...otherProps}
        >
          <div className={innerClassName} style={innerStyle}>
            {children}
          </div>
        </button>
      )}
    </BaseIconButton>
  )
}
